import React, { useCallback, useState } from 'react'

import { useDispatch } from '@hozana/redux/hooks'
import { QA } from '@hozana/tests/constants'
import { TRACKING_SOURCE, UTM } from '@hozana/tracking/constants'
import { GTM } from '@hozana/tracking/gtm'

import { RoundButton } from 'elements/button/RoundButton'
import { Div } from 'elements/layout/Div'
import { P } from 'elements/text/P'

import { ICON } from 'config/icons'
import { openPopin } from 'general/actions'
import { POPINS } from 'general/managers/popins/constants'

import type { TCommunity } from 'modules/community/types'
import { ShareContacts } from 'modules/share/components/ShareContacts'
import { ShareCopy } from 'modules/share/components/ShareCopy'
import { ShareCount } from 'modules/share/components/ShareCount'
import { ShareProvider } from 'modules/share/components/ShareProvider'
import { ShareSocial } from 'modules/share/components/ShareSocial'
import { SHARE_OBJECTS, SHARE_TYPES } from 'modules/share/constants'

export type TCommunitySharesDesktopProps = {
  community: TCommunity
}

export const CommunitySharesDesktop: TFC<TCommunitySharesDesktopProps> = ({ community }) => {
  const [isExpandedShareCopy, expandShareCopy] = useState(false)
  const dispatch = useDispatch()

  const toggleShare = useCallback(
    (value: boolean) => () => {
      expandShareCopy(value)
    },
    [],
  )

  return (
    <ShareProvider
      objectToShare={SHARE_OBJECTS.COMMUNITY}
      trackingSource={TRACKING_SOURCE.COMMUNITY_SIDEBAR}
      community={community}
      utmContent={UTM.CONTENT.COMMUNITY_PAGE_SHARE_BUTTON}
    >
      <Div data-testid={QA.COMMUNITY_PAGE.SHARE_BLOCK}>
        {!community.isPrivate && (
          <P m="10px" align="center">
            <ShareCount counts={community.sharesCount} fontSize="1em" lineHeight="1em" />
          </P>
        )}
        {!community.isPrivate && (
          <Div align="middleCenter">
            <ShareSocial
              shareTypes={[SHARE_TYPES.FACEBOOK, SHARE_TYPES.TWITTER, SHARE_TYPES.PINTEREST, SHARE_TYPES.WHATSAPP]}
            />
          </Div>
        )}
        <Div align="middleCenter" m="10px 10px 0">
          {!isExpandedShareCopy && (
            <>
              <ShareContacts />
              {!community.isPrivate && (
                <Div m="3px 6px">
                  <RoundButton
                    icon={ICON.EMBED}
                    bg="black50"
                    color="white"
                    hoverBg="black70"
                    hoverColor="white"
                    onClick={() => {
                      dispatch(openPopin(POPINS.WidgetPopin, { communityId: community.id }))
                      GTM.trackEvent(GTM.EVENTS.PARTAGE_EMBED, { trackingSource: TRACKING_SOURCE.COMMUNITY_SIDEBAR })
                    }}
                    label="trans:community:share.embed.community.title"
                    data-testid={QA.SHARE_COMMON.SOCIAL_BUTTON(SHARE_TYPES.EMBED)}
                  />
                </Div>
              )}
            </>
          )}
          <ShareCopy m="3px 6px" onShare={toggleShare(false)} onExpand={toggleShare(true)} />
        </Div>
      </Div>
    </ShareProvider>
  )
}
